import { createBrowserRouter } from 'react-router-dom';
import { env } from 'config/env';
import MainRoutes from './MainRoutes';

const router = createBrowserRouter([MainRoutes], {
  basename: env.VITE_APP_BASE_NAME
});

export default router;
